// pages/users/AdminsPage.jsx
import UserRolePage from './UserRolePage.jsx';
export default function AdminsPage() {
  return <UserRolePage role="admin" title="Admins" accentColor="#7c3aed"
    roleOptions={['admin']} />;
}